import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
} from "@mui/material";
import defaultGuidelines from "./DefaultDescriptionsSow";

import { Cross } from "../../shared/assets/icons/index";
import axios from "axios";
import Swal from "sweetalert2";

import "./vendorOnboard.css";
import { downloadExcelForInputLocations } from "../../components/AdminportalFolder/RFP/downloadExcelSheetForInputLocations";

import { handleFileUploadForLocations } from "../../components/AdminportalFolder/RFP/uploadExcelSheetForUploadingLocations";
import ProductComponent from "./ProductComponent";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import CustomButton from "../utils/Button";
import { Close } from "@mui/icons-material";
import SowReportDialog from "./SowReportModal";

const SowModal = ({
  deleteCheck,
  isProductDimensions,
  rfpData,
  isCampaignId,
  isSowModal,
  setSOWUpdateDetails,
  setIsSowModal,
  SOWUpdateDetails,
  getRfpList,
  locationListUpdate,
  getSOWIds,
  setSnackbar,
}) => {
  const [selectedPrintMachines, setSelectedPrintMachines] = useState([]);
  const [totalAreaCal, setTotalAreaCal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [isSowReportOpen, setIsSowReportOpen] = useState(false);
  const [createdSowId, setCreatedSowId] = useState("");
  const [isUpdatedSowData, setIsUpdatedData] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);

  // const sowReportRef = useRef(null);

  const handleSowReportOpen = () => {
    setIsSowReportOpen(true);
  };
  const handleSowReportClose = () => {
    setIsSowReportOpen(false);
    setIsSowModal(false);
  };
  const [scopeOfWorks, setScopeOfWorks] = useState([
    {
      id: 1,
      sowFabricationReport: "",
      sowPrintingReport: "",
      description: defaultGuidelines?.description?.detailsOfGuidelines,
      pdiGuidelines: defaultGuidelines?.pdi?.detailsOfGuidelines,
      printingGuidelines: defaultGuidelines?.printing?.detailsOfGuidelines,
      packagingGuidelines: defaultGuidelines?.packaging?.detailsOfGuidelines,
      deliveryGuidelines: defaultGuidelines?.delivery?.detailsOfGuidelines,
      fabricationGuidelines:
        defaultGuidelines?.fabrication?.detailsOfGuidelines,
      materialDetailsForPrinting: {
        productType: "",

        printMaterialsubstrate:
          SOWUpdateDetails?.materialDetailsForPrinting
            ?.printMaterialsubstrate || "",
        printMaterialbrand:
          SOWUpdateDetails?.materialDetailsForPrinting?.printMaterialbrand ||
          "",
        printMaterialgrade:
          SOWUpdateDetails?.materialDetailsForPrinting?.printMaterialgrade ||
          "",

        artWork: "",
        outerSize: "",
        printGSM: "",
        brand: "",
        applicationPlace: "", //(indoor/outdoor)
        installation: "",
      },
      productThickness: "",
      productWidth: "",
      productImage: "",
      productHeight: "",
      productSecondImg: "",
      price: SOWUpdateDetails?.price,
      totalArea: "",
      budget: "",
      printingParametersForPrinting: {
        printDPI: "",
        // colorCode: "",
        // colorCodeDetails: "",
        layer: "", // 1/2/3/4
        passes: "", // (1-12)
        printOnSides: "",
      },
      machinesNeededForPrinting: [
        {
          type: "Solvent Printing",
          details: {
            machinePrintingSubType: "",
            picoliter: "",
            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "Ecosolvent Printing",
          details: {
            machinePrintingSubType: "",
            picoliter: "",
            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "UV Printing",
          details: {
            machinePrintingSubType: "",
            picoliter: "",
            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "Latex Printing",
          details: {
            machinePrintingSubType: "",
            picoliter: "",
            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "Digital Printing",
          details: {
            machinePrintingSubType: "",
            picoliter: "",
            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "Plotter Cutting Printing",
          details: {
            machinePrintingSubType: "",

            machineBrand: "",
            maxPrintSize: "",
            ageOfMachine: "",
          },
          checked: false,
        },
      ],
      productCategoryForPrinting: "",
      productCategoryForFabrication: "",
      productCategoryForRecceInstallAudit: rfpData && rfpData?.productType,
      machinesNeededForFabrication: [
        {
          type: "Welding Machine",
          details: {
            subCategory: "",
            ampereOfMachine: "",
            // controllerSetting: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        {
          type: "Paint Compressor Machine",
          details: { subCategory: "", ageOfMachine: "" },
          checked: false,
        },
        {
          type: "CNC Router Machine",
          details: {
            subCategory: "",
            powerOfMachine: "",
            ageOfMachine: "",
            lengthFoot: "",
            breadthFoot: "",
          },
          checked: false,
        },
        {
          type: "Acrylic Laser Cutting Machine",
          details: {
            subCategory: "",
            lengthFoot: "",
            breadthFoot: "",
            ageOfMachine: "",
          },
          checked: false,
        },
        // { type: "CO2 laser", details: { Size: "", Watt: "" }, checked: false },
        {
          type: "Channel Letter Bending Machine",
          details: {
            subCategory: "",
            lengthFoot: "",
            breadthFoot: "",
            ageOfMachine: "",
            wattage: "",
            modelMachine: "",
          },
          checked: false,
        },
      ],
      areaNeededForFabrication: "",
      experienceOfFabrication: "",

      materialDetailsForFabrication: {
        // "frameDetail(Structural Frame Material)": "",
        // size: SOWUpdateDetails?.materialDetailsForFabrication?.size || "",
        frameDetailweight:
          SOWUpdateDetails?.materialDetailsForFabrication?.frameDetailweight ||
          "",
        paint: SOWUpdateDetails?.materialDetailsForFabrication?.paint || "",
        lightSourcetype:
          SOWUpdateDetails?.materialDetailsForFabrication?.lightSourcetype ||
          "",
        lightSourcebrand:
          SOWUpdateDetails?.materialDetailsForFabrication?.lightSourcebrand ||
          "",
        lightSourcemodelNo:
          SOWUpdateDetails?.materialDetailsForFabrication?.lightSourcemodelNo ||
          "",
        lightSourceqty:
          SOWUpdateDetails?.materialDetailsForFabrication?.lightSourceqty || "",
        lightSourcecolorTemp:
          SOWUpdateDetails?.materialDetailsForFabrication
            ?.lightSourcecolorTemp || "",
        lightSourcewattage:
          SOWUpdateDetails?.materialDetailsForFabrication?.lightSourcewattage ||
          "",

        backingmaterial:
          SOWUpdateDetails?.materialDetailsForFabrication?.backingmaterial ||
          "",
        backingthickness:
          SOWUpdateDetails?.materialDetailsForFabrication?.backingthickness ||
          "",
        backinggrade:
          SOWUpdateDetails?.materialDetailsForFabrication?.backinggrade || "",
        raisingheight:
          SOWUpdateDetails?.materialDetailsForFabrication?.raisingheight || "",
        raisinggrade:
          SOWUpdateDetails?.materialDetailsForFabrication?.raisinggrade || "",
        raisingthickness:
          SOWUpdateDetails?.materialDetailsForFabrication?.raisingthickness ||
          "",
        raisingmaterial:
          SOWUpdateDetails?.materialDetailsForFabrication?.raisingmaterial ||
          "",

        cadFile: SOWUpdateDetails?.materialDetailsForFabrication?.cadFile || "",
        specificationFile:
          SOWUpdateDetails?.materialDetailsForFabrication?.specificationFile ||
          "",

        applicationPlace:
          SOWUpdateDetails?.materialDetailsForFabrication?.[0]
            ?.applicationPlace || "",
        face: SOWUpdateDetails?.materialDetailsForFabrication?.face || "",
        wiring: SOWUpdateDetails?.materialDetailsForFabrication?.wiring || "",
        specialMentions:
          SOWUpdateDetails?.materialDetailsForFabrication?.specialMentions ||
          "",
      },
      locationsListForInstallation: [],
      servicesNeeded: rfpData.servicesNeeded.filter((ele) => ele != null),
      locationsList: [],
      productDimensions: [],
    },
  ]);
  console.log("scopw", scopeOfWorks);

  // const [disableSaveButton, setDisableSaveButton] = useState();

  // const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  // const [errors, setErrors] = useState({});
  useEffect(() => {
    if (SOWUpdateDetails) {
      setScopeOfWorks((prevState) =>
        prevState.map((scope, index) => ({
          ...scope,
          materialDetailsForPrinting: {
            ...scope.materialDetailsForPrinting,
            ...(SOWUpdateDetails.materialDetailsForPrinting || {}),
          },
          sowFabricationReport:
            SOWUpdateDetails.sowFabricationReport || scope.sowFabricationReport,
          description: SOWUpdateDetails.description || scope.description,
          pdiGuidelines: SOWUpdateDetails.pdiGuidelines || scope.pdiGuidelines,
          fabricationGuidelines:
            SOWUpdateDetails.fabricationGuidelines ||
            scope.fabricationGuidelines,
          packagingGuidelines:
            SOWUpdateDetails.packagingGuidelines || scope.packagingGuidelines,
          deliveryGuidelines:
            SOWUpdateDetails.deliveryGuidelines || scope.deliveryGuidelines,
          printingGuidelines:
            SOWUpdateDetails.printingGuidelines || scope.printingGuidelines,
          sowPrintingReport:
            SOWUpdateDetails.sowPrintingReport || scope.sowPrintingReport,
          productThickness:
            SOWUpdateDetails.productThickness || scope.productThickness,
          productCategoryForRecceInstallAudit:
            SOWUpdateDetails.productCategoryForRecceInstallAudit
              ? SOWUpdateDetails.productCategoryForRecceInstallAudit
              : rfpData.productType,

          productWidth: SOWUpdateDetails.productWidth || scope.productWidth,
          productHeight: SOWUpdateDetails.productHeight || scope.productHeight,
          price: SOWUpdateDetails.price || scope.price,
          totalArea: SOWUpdateDetails.totalArea || scope.totalArea,
          budget: SOWUpdateDetails.budget || scope.budget,
          printingParametersForPrinting: {
            ...scope.printingParametersForPrinting,
            ...(SOWUpdateDetails.printingParametersForPrinting || {}),
          },
          machinesNeededForPrinting: scope.machinesNeededForPrinting.map(
            (machine) => {
              const matchingMachine =
                SOWUpdateDetails.machinesNeededForPrinting?.find(
                  (updatedMachine) => updatedMachine.type === machine.type
                );

              return {
                ...machine,
                details: {
                  ...machine.details,
                  ...(matchingMachine?.details || {}), // Merge details if a match is found
                },
                checked: matchingMachine?.checked ?? machine.checked, // Update checked if provided, fallback to existing
              };
            }
          ),
          productCategoryForPrinting:
            SOWUpdateDetails.productCategoryForPrinting ||
            scope.productCategoryForPrinting,
          productCategoryForFabrication:
            SOWUpdateDetails.productCategoryForFabrication ||
            scope.productCategoryForFabrication,
          machinesNeededForFabrication: scope.machinesNeededForFabrication.map(
            (machine) => {
              // Find a matching machine in the SOWUpdateDetails based on type
              const matchingMachine =
                SOWUpdateDetails.machinesNeededForFabrication?.find(
                  (updatedMachine) => updatedMachine.type === machine.type
                );

              return {
                ...machine,
                details: {
                  ...machine.details,
                  ...(matchingMachine?.details || {}), // Merge details if a match is found
                },
                checked: matchingMachine?.checked ?? machine.checked, // Update checked if provided, fallback to existing
              };
            }
          ),

          areaNeededForFabrication:
            SOWUpdateDetails.areaNeededForFabrication ||
            scope.areaNeededForFabrication,
          experienceOfFabrication:
            SOWUpdateDetails.experienceOfFabrication ||
            scope.experienceOfFabrication,
          materialDetailsForFabrication: {
            ...scope.materialDetailsForFabrication,
            ...(SOWUpdateDetails.materialDetailsForFabrication || {}),
          },
          servicesNeeded: SOWUpdateDetails.servicesNeeded
            ? SOWUpdateDetails.servicesNeeded
            : rfpData?.servicesNeeded,
          locationsList: locationListUpdate || scope.locationsList,
          productDimensions: isProductDimensions || scope.productDimensions,
          printImage: isProductDimensions?.[0]?.printImage || scope.printImage,
          productSecondImg:
            isProductDimensions?.[0]?.productSecondImg ||
            scope.productSecondImg,
          // price: SOWUpdateDetails.price || scope.price,
        }))
      );
    }
  }, [SOWUpdateDetails]);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [errors, setErrors] = useState({});

  const serverURL = process.env.REACT_APP_URL;
  const handleClose = () => {
    setIsSowModal(false);
    setSOWUpdateDetails(null);
  };
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [otherSelectedIndexes, setOtherSelectedIndexes] = useState([]);

  // UseEffect to recalculate totalArea and budget
  const prevScopeOfWorks = useRef(scopeOfWorks); // UseRef to store the previous state

  useEffect(() => {
    if (!scopeOfWorks[0]?.productDimensions) return;

    let area = 0;
    let campaignPrice = 0;

    for (let i = 0; i < scopeOfWorks[0].productDimensions.length; i++) {
      area +=
        (scopeOfWorks[0]?.productDimensions[i]?.productHeight || 0) *
        (scopeOfWorks[0]?.productDimensions[i]?.productWidth || 0);
    }

    campaignPrice = (scopeOfWorks[0]?.price || 0) * area;

    // Update scopeOfWorks with new values
    setScopeOfWorks((prevScope) => {
      const updatedScope = [...prevScope];
      updatedScope[0] = {
        ...updatedScope[0],
        totalArea: area,
        budget: campaignPrice,
      };
      return updatedScope;
    });
  }, [scopeOfWorks[0]?.productDimensions, scopeOfWorks[0]?.price]);

  const validateForm = (formData, index) => {
    const newErrors = {};
    if (!scopeOfWorks[index]?.locationsList?.length) {
      newErrors[`locationsList-${index}`] = "Location is required";
    }
    if (!scopeOfWorks[index]?.price) {
      newErrors[`price-${index}`] = "Price is required";
    }

    // if (
    //   formData.servicesNeeded.includes("Printing") &&
    //   !formData.productCategoryForPrinting
    // ) {
    //   newErrors.productType = "Product Category is required";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  const handleDeleteUpload = async (keys = []) => {
    if (!keys.length) return;

    try {
      const response = await axios.post(
        `${serverURL}/deleteUpload`,
        { keys },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success === true) {
      } else {
        console.warn("Failed to delete:", response.data.message);
      }
    } catch (error) {
      console.error("Error deleting upload:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveButtonClicked(true);

    // Validate each scope of work
    const isValid = scopeOfWorks.every((scopeOfWork, index) =>
      validateForm(scopeOfWork, index)
    );

    if (!isValid) {
      console.error("Form validation failed. Please fill the errors.", errors);
      setSnackbar({
        open: true,
        message: "Form validation failed. Please fill the required fields.",
        severity: "error",
      });
      return; // Stop submission if validation fails
    }

    if (SOWUpdateDetails?._id) {
      // Update logic
      setIsLoading(true);
      const reportsData = scopeOfWorks
        .flatMap((scopeOfWork) => [
          scopeOfWork.sowFabricationReport,
          scopeOfWork.sowPrintingReport,
        ])
        .filter(Boolean);

      const updatedScopeOfWorks = scopeOfWorks.map((item) => {
        let updatedItem = {
          ...item,
          sowPrintingReport: "",
          sowFabricationReport: "",
        };

        const fabricationNotNeeded = !item?.servicesNeeded?.some((ele) =>
          ele.includes("Fabrication")
        );

        if (fabricationNotNeeded) {
          updatedItem = {
            ...updatedItem,
            sowFabricationReport: "",
            machinesNeededForFabrication: [],
            materialDetailsForFabrication: {},
          };
        }
        const printingNotNeeded = !item.servicesNeeded?.some((ele) =>
          ele.includes("Printing")
        );

        if (printingNotNeeded) {
          updatedItem = {
            ...updatedItem,
            sowPrintingReport: "",
            machinesNeededForPrinting: [],
            materialDetailsForPrinting: {},
          };
        }

        return updatedItem;
      });
      if (isDeleted) {
        setIsLoading(true);
        try {
          if (SOWUpdateDetails?._id) {
            const response = await axios.delete(
              `${process.env.REACT_APP_URL}/product/deleteSOWJobLocations/${SOWUpdateDetails._id}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            if (response?.data?.success) {
              try {
                const response = await axios.put(
                  `${serverURL}/product/updateSOW/${SOWUpdateDetails._id}`, // Assuming `SOWUpdateDetails.id` is the ID of the item to update
                  {
                    scopeOfWorks: updatedScopeOfWorks,
                    rfpData,
                    campaignId: isCampaignId,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  }
                );

                if (response.data.success) {
                  setIsLoading(false);
                  handleSowReportOpen();

                  // setIsSowModal(false);
                  setCreatedSowId(response?.data?.data?._id);

                  setIsUpdatedData(response.data.data);
                  handleDeleteUpload(reportsData);

                  setSnackbar({
                    open: true,
                    message: response.data.message || "SOW Update Successful",
                    severity: "success",
                  });
                  getSOWIds(); // Refresh or reload data
                  setSOWUpdateDetails(null);
                } else {
                  Swal.fire({
                    title: "Error!",
                    text:
                      response.data.error ||
                      "Failed to update SOW. Please try again.",
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                  setSnackbar({
                    open: true,
                    message:
                      response.data.error ||
                      "Failed to update SOW. Please try again.",
                    severity: "error",
                  });
                  setIsLoading(false);
                }
              } catch (err) {
                console.error(err);
                setSnackbar({
                  open: true,
                  message:
                    "An error occurred while updating SOW. Please try again.",
                  severity: "error",
                });
                setIsLoading(false);
              }
            }
          }
        } catch (error) {
          console.error("error while deleting excel", error);
        }
      } else if (!isDeleted && SOWUpdateDetails?._id) {
        setIsLoading(true);

        try {
          const response = await axios.put(
            `${serverURL}/product/updateSOW/${SOWUpdateDetails._id}`, // Assuming `SOWUpdateDetails.id` is the ID of the item to update
            {
              scopeOfWorks: updatedScopeOfWorks,
              rfpData,
              campaignId: isCampaignId,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (response.data.success) {
            setIsLoading(false);
            handleSowReportOpen();

            // setIsSowModal(false);
            setCreatedSowId(response?.data?.data?._id);

            setIsUpdatedData(response.data.data);
            handleDeleteUpload(reportsData);

            setSnackbar({
              open: true,
              message: response.data.message || "SOW Update Successful",
              severity: "success",
            });
            getSOWIds(); // Refresh or reload data
            setSOWUpdateDetails(null);
          } else {
            Swal.fire({
              title: "Error!",
              text:
                response.data.error ||
                "Failed to update SOW. Please try again.",
              icon: "error",
              confirmButtonText: "OK",
            });
            setSnackbar({
              open: true,
              message:
                response.data.error ||
                "Failed to update SOW. Please try again.",
              severity: "error",
            });
            setIsLoading(false);
          }
        } catch (err) {
          console.error(err);
          setSnackbar({
            open: true,
            message: "An error occurred while updating SOW. Please try again.",
            severity: "error",
          });
          setIsLoading(false);
        }
      }
    } else {
      // Create logic
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${serverURL}/product/createProduct`,
          { scopeOfWorks, rfpData },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.data.success) {
          setIsLoading(false);
          setCreatedSowId(response?.data?.campaignData?.scopeOfWorkId);
          handleSowReportOpen();

          // setIsSowModal(false);
          setSnackbar({
            open: true,
            message: "SOW Successful Created",
            severity: "success",
          });
          getSOWIds(); // Refresh or reload data
          setSOWUpdateDetails(null);
        } else {
          Swal.fire({
            title: "Error!",
            text: "Please Enter Required Fields",
            icon: "error",
            confirmButtonText: "OK",
          });
          setSnackbar({
            open: true,
            message: "Please Enter Required Fields",
            severity: "error",
          });
          setIsLoading(false);
        }
      } catch (err) {
        console.error(err);
        setSnackbar({
          open: true,
          message: "An error occurred while creating SOW. Please try again.",
          severity: "error",
        });
        setIsLoading(false);
      }
    }
  };

  const handleInputChange = async (e, i) => {
    const updatedScopeOfWork = scopeOfWorks;
    const { name, value } = e.target;
    const scopeOfWork = updatedScopeOfWork[i];
    if (name.split("-")[0] === "materialDetailsForFabrication") {
      scopeOfWork.materialDetailsForFabrication[name.split("-")[1]] = value;
    }
    if (name.split("-")[0] === "machinesNeededForFabrication") {
      // find m/c
      let index = scopeOfWork.machinesNeededForFabrication.findIndex(
        (machine) => machine.type === name.split("-")[2]
      );
      scopeOfWork.machinesNeededForFabrication[index].details[
        name.split("-")[3]
      ] = value;
      if (name.split("-")[3] === "lengthFoot") {
        const mapping = getMapping(name.split("-")[2]);
        scopeOfWork.machinesNeededForFabrication[index].details["breadthFoot"] =
          mapping[value];
      }
    }
    if (name.split("-")[0] === "machinesNeededForPrinting") {
      // find m/c
      let index = scopeOfWork.machinesNeededForPrinting.findIndex(
        (machine) => machine.type === name.split("-")[2]
      );
      scopeOfWork.machinesNeededForPrinting[index].details[name.split("-")[3]] =
        value;
      // console.log("name is:", name, "afterSplit:", name.split("-"), value);
    }

    if (name.split("-")[0] === "machinesNeededForPrinting") {
      let index = scopeOfWork.machinesNeededForPrinting.findIndex(
        (machine) => machine.type === name.split("-")[2]
      );

      if (
        scopeOfWork.machinesNeededForPrinting[index].details.machineBrand ===
        "Other"
      ) {
        scopeOfWork.machinesNeededForPrinting[index].details.machineBrand = "";
      }
    }
    if (name.split("-")[0] === "productCategoryForPrinting") {
      let index = scopeOfWork.machinesNeededForPrinting.findIndex(
        (machine) => machine.type === name.split("-")[2]
      );

      // console.log("inner", scopeOfWork.machinesNeededForPrinting[index]);
    }

    if (name === `experienceOfFabrication-${i}`) {
      scopeOfWork.experienceOfFabrication = value;
    }
    // if (
    //   name === `machinesNeededForFabrication-details-Paint Compressor-Have-${i}`
    // ) {
    //   scopeOfWork.machinesNeededForFabrication.forEach((machine, machineIndex) => {
    //     if (machine. === i) {
    //       machine.details.paintCompressor.have = value;
    //     }
    //   });
    //   console.log("Paint", value, name);
    // }
    if (name === `productCategoryForRecceInstallAudit-${i}`) {
      scopeOfWork.productCategoryForRecceInstallAudit = value;
    }
    if (name === `description-${i}`) {
      scopeOfWork.description = value;
    }
    if (name === `fabricationGuidelines-${i}`) {
      scopeOfWork.fabricationGuidelines = value;
    }
    if (name === `pdiGuidelines-${i}`) {
      scopeOfWork.pdiGuidelines = value;
    }
    if (name === `packagingGuidelines-${i}`) {
      scopeOfWork.packagingGuidelines = value;
    }
    if (name === `deliveryGuidelines-${i}`) {
      scopeOfWork.deliveryGuidelines = value;
    }
    if (name === `printingGuidelines-${i}`) {
      scopeOfWork.printingGuidelines = value;
    }
    if (name === `areaNeededForFabrication-${i}`) {
      scopeOfWork.areaNeededForFabrication = value;
    }
    if (name === `servicesNeeded-${i}`) {
      scopeOfWork.servicesNeeded = value;
    }
    if (name === `productCategoryForPrinting-${i}`) {
      scopeOfWork.productCategoryForPrinting = value;
    }
    if (name === `productCategoryForFabrication-${i}`) {
      scopeOfWork.productCategoryForFabrication = value;
    }
    if (name === `outerSize-${i}`) {
      scopeOfWork.materialDetailsForPrinting.outerSize = value;
    }
    if (name === `printMaterialsubstrate-${i}`) {
      scopeOfWork.materialDetailsForPrinting.printMaterialsubstrate = value;
    }
    if (name === `printMaterialbrand-${i}`) {
      scopeOfWork.materialDetailsForPrinting.printMaterialbrand = value;
    }
    if (name === `printMaterialgrade-${i}`) {
      scopeOfWork.materialDetailsForPrinting.printMaterialgrade = value;
    }
    if (name === `applicationPlace-${i}`) {
      scopeOfWork.materialDetailsForPrinting.applicationPlace = value;
    }
    if (name === `installationtableTop-${i}`) {
      scopeOfWork.materialDetailsForPrinting.installationtableTop = value;
    }
    if (name === `installationfloor-${i}`) {
      scopeOfWork.materialDetailsForPrinting.installationfloor = value;
    }
    if (name === `installationprojected-${i}`) {
      scopeOfWork.materialDetailsForPrinting.installationprojected = value;
    }
    if (name === `installationceiling-${i}`) {
      scopeOfWork.materialDetailsForPrinting.installationceiling = value;
    }
    if (name === `installationwall-${i}`) {
      scopeOfWork.materialDetailsForPrinting.installationwall = value;
    }
    if (name === `artWork-${i}`) {
      scopeOfWork.materialDetailsForPrinting.artWork = value;
    }
    if (name === `brand-${i}`) {
      scopeOfWork.materialDetailsForPrinting.brand = value;
    }
    if (name === `printMaterial-${i}`) {
      scopeOfWork.materialDetailsForPrinting.printMaterial = value;
    }
    if (name === `productHeight-${i}`) {
      scopeOfWork.productHeight = value;
    }
    if (name === `productWidth-${i}`) {
      scopeOfWork.productWidth = value;
    }
    if (name === `productThickness-${i}`) {
      scopeOfWork.productThickness = value;
    }
    // if (name === `printType-${i}`) {
    //   scopeOfWork.materialDetailsForPrinting.printType = value;
    // }
    if (name === `price-${i}`) {
      scopeOfWork.price = value;
      scopeOfWork.totalArea = totalAreaCal;
      scopeOfWork.totalCampaignArea = scopeOfWork.price * totalAreaCal;
    }

    if (name === `printGSM-${i}`) {
      scopeOfWork.materialDetailsForPrinting.printGSM = value;
    }
    if (name === `oemPreference-${i}`) {
      scopeOfWork.materialDetailsForPrinting.oemPreference = value;
    }
    if (name === `locationsList-${i}`) {
      let response = await handleFileUploadForLocations(
        e,
        setExcelLoading,
        setSnackbar
      );
      if (response == undefined) {
        scopeOfWork.locationsList = [];
        scopeOfWork.productDimensions = [];
        setExcelLoading(false);
      }
      if (response?.success === true) {
        scopeOfWork.productDimensions = response?.products;
        scopeOfWork.locationsList = response?.jobLocations;
        setExcelLoading(false);
      }

      if (response) {
        setErrors((prevErrors) => ({
          [`locationsList-${i}`]: "",
        }));
      }
    }
    if (name === `printDPI-${i}`) {
      scopeOfWork.printingParametersForPrinting.printDPI = value;
    }
    if (name === `colorCodeDetails-${i}`) {
      scopeOfWork.printingParametersForPrinting.colorCodeDetails = value;
    }
    if (name === `colorCode-${i}`) {
      scopeOfWork.printingParametersForPrinting.colorCode = value;
    }
    if (name === `layer-${i}`) {
      scopeOfWork.printingParametersForPrinting.layer = value;
    }
    if (name === `passes-${i}`) {
      scopeOfWork.printingParametersForPrinting.passes = value;
    }
    if (name === `printOnSides-${i}`) {
      scopeOfWork.printingParametersForPrinting.printOnSides = value;
    }
    // console.log({ updatedScopeOfWork });

    setScopeOfWorks([...updatedScopeOfWork]);
  };

  return (
    <div>
      <Dialog open={isSowModal} maxWidth="xl" fullWidth>
        <DialogTitle>
          <div className="flex justify-between w-full  bg-[var(--secondary-color)]   px-4 rounded-t-lg">
            <div className="flex flex-col items-baseline">
              <h1 className=" text-[20px] ml-4 mb-1 font-[600]">
                Scope Of Work
              </h1>
              <h2 className="mt-1 font-semibold flex gap-1">
                {`Campaign Name:`}
                <h2 className="text-[var(--heading-color)] font-[600]">
                  {(rfpData?.campaignName &&
                    rfpData?.campaignName.charAt(0).toUpperCase() +
                      rfpData?.campaignName.slice(1)) ||
                    "N/A"}
                </h2>
              </h2>
            </div>
            <div className="flex justify-center items-center mr-10">
              <button
                className="py-2 w-full lg:w-[240px] text-[14px] text-blue-500 flex items-center justify-center border border-blue-500 rounded-md hover:bg-blue-500 hover:text-white transition duration-300"
                onClick={() => downloadExcelForInputLocations()}
              >
                <ArrowCircleDownIcon
                  className="mr-1"
                  color="inherit"
                  size={18}
                />
                Download Sites Template
              </button>

              <div className="mx-5 my-4 absolute top-0 right-0">
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid
            spacing={1}
            className="flex md:flex items-start justify-start gap-2 rounded-sm "
          >
            {scopeOfWorks?.map((scopeOfWork, i) => (
              <div
                key={i}
                className="flex flex-col items-center justify-center w-full  "
              >
                <ProductComponent
                  deleteCheck={deleteCheck}
                  setIsDeleted={setIsDeleted}
                  excelLoading={excelLoading}
                  setSelectedPrintMachines={setSelectedPrintMachines}
                  selectedPrintMachines={selectedPrintMachines}
                  SOWUpdateDetails={SOWUpdateDetails}
                  isOtherSelected={isOtherSelected}
                  otherSelectedIndexes={otherSelectedIndexes}
                  setOtherSelectedIndexes={setOtherSelectedIndexes}
                  handleInputChange={handleInputChange}
                  scopeOfWork={scopeOfWork}
                  handleSubmit={handleSubmit}
                  saveButtonClicked={saveButtonClicked}
                  setSaveButtonClicked={setSaveButtonClicked}
                  scopeOfWorks={scopeOfWorks}
                  setScopeOfWorks={setScopeOfWorks}
                  validateForm={validateForm}
                  index={i}
                  setIsSowModal={setIsSowModal}
                  isLoading={isLoading}
                  errors={errors}
                />
              </div>
            ))}

            {/* <div className="w-full flex justify-end mt-3">
              <CustomButton className="w-[180px] " text="Save"></CustomButton>
            </div>
            <div
              className="w-full border-[var(--primary-color)] rounded-md  mt-3 flex justify-center items-center px-2 py-2 "
              style={{ border: "2px solid var(--primary-color)" }}
            >
              <p className="text-[var(--primary-color)] text-[14px]">
                + Add Product
              </p>
            </div> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="flex justify-end items-center gap-3">
            <div
              className="text-[var(--primary-color)] cursor-pointer"
              onClick={handleClose}
            >
              CLOSE
            </div>
            <div className="w-full flex justify-end ">
              {scopeOfWorks[0]?.servicesNeeded.length === 0 ? (
                // Disabled Button
                <button
                  disabled
                  className="w-[100px] rounded-lg p-2 cursor-not-allowed bg-gray-300  text-gray-400"
                  text="Save"
                >
                  SAVE
                </button>
              ) : (
                <CustomButton
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  className="w-[100px]"
                  text={SOWUpdateDetails?._id ? "UPDATE" : "SAVE"}
                />
              )}
            </div>
          </div>
        </DialogActions>
        {isSowReportOpen && (
          <SowReportDialog
            open={isSowReportOpen}
            onClose={handleSowReportClose}
            updatedSowData={isUpdatedSowData}
            rfpData={rfpData}
            campaignId={isCampaignId}
            // sowReportRef={sowReportRef}
            createdSowId={createdSowId}
            getSOWIds={getSOWIds}
            scopeOfWorks={scopeOfWorks}
            setScopeOfWorks={setScopeOfWorks}
          />
        )}
      </Dialog>
    </div>
  );
};

export default SowModal;
let getMapping = (machine) => {
  if (machine === "CNC Router Machine") return lengthWidthMapping;
  if (machine === "Acrylic Laser Cutting Machine") return AcrylicWidthMapping;
  if (machine === "Channel Letter Bending Machine")
    return channelLetterWidthMapping;
  return {};
};
let lengthWidthMapping = {
  8: "4",
  10: "5",
  12: "5",
};
let AcrylicWidthMapping = {
  2: "3",
  3: "4",
  8: "4",
};

let channelLetterWidthMapping = {
  5: "3",
  4: "3",
  3: "2",
};
